import { createPortal } from 'react-dom';
import { useState } from 'react';
import { deleteLLMProps } from './llm.props';
import BasicModal from '../../../../components/action-modal';
import { deleteModel } from '../services/llm';
import makeToast from '../../../../components/toaster';
import Logout from '../../../../auth/protected/session-expire-modal';
import { reloadUserConfigurationsAfterLlmChange } from '../../user/services';

function DeleteModel({
  open,
  setDeleteLLMModalOpen,
  dataToDelete,
  setDataUpdated,
  setDataToDelete,
}: deleteLLMProps) {
  const [logout, setLogout] = useState(false);
  const handleCancelClick = () => {
    setDeleteLLMModalOpen(false);
    setDataToDelete([]);
  };

  const handleDeleteLLM = () => {
    deleteModel(dataToDelete)
      ?.then((res) => {
        if (res.status === 200) {
          setDataUpdated((prev: boolean) => !prev);
          reloadUserConfigurationsAfterLlmChange();
          setDeleteLLMModalOpen(false);
          makeToast('success', 'LLM has been deleted!');
          setDataToDelete([]);
        } else if (res.status === 401) {
          setLogout(true);
        }
      })
      .catch((err) => {
        setDeleteLLMModalOpen(false);
        makeToast(
          'error',
          err?.response?.data?.message
            ? `${err?.response?.data?.message}.`
            : 'Something went wrong!',
        );
        setDataToDelete([]);
      });
  };

  return (
    <BasicModal
      className="w-[400px]"
      open={open}
      resetData={handleCancelClick}
      confirmButtonText="Delete"
      saveData={handleDeleteLLM}
    >
      <span className="font-semibold text-center pb-3">
        {`Are you sure you want to delete selected ${
          dataToDelete?.length === 1 ? ' llm?' : 'llms?'
        }`}
      </span>
      {logout && createPortal(<Logout />, document.body)}
    </BasicModal>
  );
}

export default DeleteModel;
